<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">
<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Open+Sans:wght@400;500;600&display=swap" rel="stylesheet">
  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>
<script>
 document.querySelector('.mobile-toggle').addEventListener('click', () => {
  document.querySelector('.main-nav').style.display =
    document.querySelector('.main-nav').style.display === 'block'
      ? 'none'
      : 'block';
});

document.querySelectorAll('.dropdown > a').forEach(link => {
  link.addEventListener('click', e => {
    if (window.innerWidth <= 992) {
      e.preventDefault();
      link.parentElement.classList.toggle('active');
    }
  });
});

</script>





<header class="main-header" id="head1">
  <!-- Franja superior -->
  <div class="top-bar" style="border-bottom: none;">
    <div class="top-container">

      <div class="top-left"></div>

      <div class="top-center">
        <img style="margin-left: -6vh;" src="https://i.imgur.com/FmpJ9BD.png" alt="Resolviendo de la mano">
      </div>

      <div class="top-right social-icons">
        <a href="https://www.facebook.com/difcasimirocastillooficial" target="_blank"><img src="https://i.imgur.com/jQcvZZ2.png" alt="Facebook"></a>

      </div>

    </div>
  </div>

  <!-- Barra principal -->
  <div class="nav-bar">
    <div class="nav-container">

      <!-- Logo -->
      <div class="brand">
        <img src="https://i.imgur.com/RihGgb5.png" alt="Casimiro Castillo">
      </div>

      <!-- Menú -->
  <nav class="main-nav">
  <ul class="menu">


    <li class="dropdown">
      <a style="font-weight: bold;" href="/admin/inicio">Inicio</a>

    </li>

    <li class="dropdown">
      <a style="font-weight: bold;">Sistema Dif</a>
      <ul class="submenu">
        <li><a >Equipo de Trabajo</a></li>
        <li><a >Organigrama</a></li>
      </ul>
    </li>

    <li class="dropdown">
      <a style="font-weight: bold;" href="/admin/tramites-y-servicios" >Programas y servicios</a>

    </li>

    <li class="dropdown">
      <a style="font-weight: bold;" href="/admin/articulo-8">Transparencia</a>
      <ul class="submenu">
        <li><a href="/admin/articulo-8">Artículo 8</a></li>
        <li><a href="/admin/articulo-8/fraccion-14">SEVAC</a></li>
      </ul>
    </li>





    <li class="dropdown">
      <a style="font-weight: bold;">Ayuntamiento</a>

    </li>

  </ul>
</nav>


      <!-- Menú móvil -->
      <div class="mobile-toggle">☰</div>

    </div>
  </div>
</header>
